import { ReactNode } from 'react';
import { Box, LinkButton, Paragraph, Radio } from '../../../atoms';
import { MoneyTemplateCard } from '../money-template-card/money-template-card';

export type SelectableTileCardProps = {
  /**
   * To be rendered above the body content.
   */
  children?: ReactNode;
  title: string;
  /**
   * To be shown below the title.
   */
  subtitle?: string;
  selected: boolean;
  /**
   * @default false
   */
  isDisabled?: boolean;
  /**
   * Optional action to display in the tile. e.g activate budget
   */
  actionLink?: {
    hidden?: boolean;
    isExternal?: boolean;
    /**
     * route of the url
     */
    to: string;
    text: string;
    onClick?: () => void;
    /**
     * @default false
     */
    isDisabled?: boolean;
  };
  /**
   * Called when the card is clicked.
   */
  onClick?: () => void;
};

export function SelectableTileCard({
  children,
  title,
  subtitle,
  actionLink,
  selected,
  onClick
}: SelectableTileCardProps): JSX.Element {
  const shadow = selected ? 'md' : 'none';

  return (
    <MoneyTemplateCard
      borderRadius="md"
      flexBasis={{ base: '65%', md: '45%', lg: '25%' }}
      flexShrink={0}
      boxShadow={shadow}
      variant={selected ? 'selected' : 'default'}
      _hover={{
        cursor: 'pointer'
      }}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {children}
      <MoneyTemplateCard.Body
        padding="space_unit.x4"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box data-testid={`selectable-tile-${title}`}>
          <Paragraph fontWeight="bold" size="md">
            {title}
          </Paragraph>
          {subtitle && <Paragraph fontSize="md">{subtitle}</Paragraph>}
          {actionLink && actionLink?.hidden === false && (
            <LinkButton
              isExternal={actionLink?.isExternal}
              variant="link"
              onClick={(e) => {
                e.stopPropagation();
                actionLink?.onClick && actionLink?.onClick();
              }}
              to={actionLink?.to}
            >
              {actionLink?.text}
            </LinkButton>
          )}
        </Box>
        <Box>
          <Radio isReadOnly isChecked={selected} />
        </Box>
      </MoneyTemplateCard.Body>
    </MoneyTemplateCard>
  );
}
